import classnames from 'classnames';
import { SimpleImage } from '@components/common/SimpleImage';
import { UiKitButton } from '@components/common/ui-kit-button';
import { ButtonGroup } from '@features/Unsubscribe/components/ButtonGroup';
import { Container } from '@features/Unsubscribe/components/Container';
import { Title } from '@features/Unsubscribe/components/Title';
import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import type { TpWizardSteps } from '@features/Unsubscribe/types';
import styles from './Error.module.scss';
export const Error = (props: TpWizardSteps) => {
  const {
    defaultEventOptions,
    trackUnsubscribeEvent
  } = useUnsubscribeAnalytics();
  const handleTryAgain = () => {
    trackUnsubscribeEvent('cancel_error_try_again_tapped');
    props.wizard.previousStep();
  };
  return <Container className={styles.container} eventOnMounted="cancel_error_opened" eventOptions={defaultEventOptions} data-sentry-element="Container" data-sentry-component="Error" data-sentry-source-file="index.tsx">
      <div className={classnames('double-grow', styles.content)}>
        <SimpleImage src="error-icon.svg" width="137" height="137" alt="error" data-sentry-element="SimpleImage" data-sentry-source-file="index.tsx" />
        <Title className={styles.title} data-sentry-element="Title" data-sentry-source-file="index.tsx">
          Error: subscription was not canceled
        </Title>

        <p className={styles.description}>
          Please re-open the app and try again. <br /> Contact our support team
          if the error persists
        </p>
      </div>
      <ButtonGroup data-sentry-element="ButtonGroup" data-sentry-source-file="index.tsx">
        <UiKitButton className={styles.button} onClick={handleTryAgain} fullWidth data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
          Try Again
        </UiKitButton>
      </ButtonGroup>
    </Container>;
};